import { GALLERY_SITES } from '@/pages/landing/gallery';

export type Starter = {
  id: string;
  icon: string;
  label: string;
  outcome: string;
};

export type ComposerKind = 'playbook' | 'skill';

export type ComposerPillar = {
  id: string;
  label: string;
  badge: string;
};

export type ComposerItem = {
  id: string;
  kind: ComposerKind;
  title: string;
  tagline: string;
  description: string;
  category: string;
  author: string;
  authorInitials: string;
  rating: number;
  reviews: number;
  score: number;
  steps: number;
  price: number;
  tags: string[];
  image: string;
  color: string;
  featured?: boolean;
  listingId?: string;
  pillars: ComposerPillar[];
  contextCount: number;
  diagram: string;
  inCount: number;
  outCount: number;
};

export type ChatSize = 'pinned' | 'expanded' | 'full';

export type ChatMessage = {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  time: string;
};

export const STARTERS: Starter[] = GALLERY_SITES.filter((s) => !s.href).map((s) => ({
  id: s.id,
  icon: s.icon,
  label: s.label,
  outcome: s.outcome,
}));

export const KEYWORD_SKILLS: { keys: string[]; skillId: string }[] = [
  { keys: ['review', 'code', 'bug', 'quality', 'diff', 'style', 'readab', 'changed'], skillId: 'code-review' },
  { keys: ['lint', 'fix', 'format'], skillId: 'lint-fix' },
  { keys: ['test', 'cover', 'unit', 'catch', 'bug'], skillId: 'test-gen' },
  { keys: ['perf', 'performance', 'slow', 'regress', 'speed', 'fast'], skillId: 'perf-audit' },
  { keys: ['security', 'scan', 'vuln', 'safe', 'inject', 'secret', 'gate', 'block', 'critical'], skillId: 'security-scan' },
  { keys: ['depend', 'cve', 'package', 'library'], skillId: 'dep-check' },
  { keys: ['doc', 'docstring', 'documentation', 'readme'], skillId: 'doc-gen' },
  { keys: ['summary', 'pr', 'merge', 'description', 'describe', 'changes'], skillId: 'pr-summary' },
];

export function nowTime() {
  const d = new Date();
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function filterComposerItems(
  items: ComposerItem[],
  opts: { category: string; query: string },
): ComposerItem[] {
  const q = opts.query.toLowerCase().trim();
  return items.filter((item) => {
    if (opts.category === 'playbooks' && item.kind !== 'playbook') return false;
    if (opts.category === 'skills' && item.kind !== 'skill') return false;
    if (
      opts.category !== 'all' &&
      opts.category !== 'playbooks' &&
      opts.category !== 'skills' &&
      item.category !== opts.category
    ) {
      return false;
    }
    if (!q) return true;
    return (
      item.title.toLowerCase().includes(q) ||
      item.tagline.toLowerCase().includes(q) ||
      item.description.toLowerCase().includes(q) ||
      item.category.toLowerCase().includes(q) ||
      item.kind.toLowerCase().includes(q) ||
      item.tags.some((t) => t.toLowerCase().includes(q))
    );
  });
}
